import { C } from "../../lib/colors";

export const IllustrationClients = () => (
  <svg viewBox="0 0 320 200" fill="none" xmlns="http://www.w3.org/2000/svg" style={{width:"100%",height:"100%"}}>
    <rect width="320" height="200" rx="16" fill="#0C0F1A"/>
    {[
      {name:"Sunrise Dental",status:"active",budget:"$800",color:C.green,y:20},
      {name:"Peak Roofing Co.",status:"prospect",budget:"$500",color:C.amber,y:72},
      {name:"Luxe Properties",status:"active",budget:"$1,200",color:C.blue,y:124},
    ].map((c,i)=>(
      <g key={i}>
        <rect x="16" y={c.y} width="288" height="44" rx="10" fill="#111520" stroke="rgba(255,255,255,0.07)" strokeWidth="1"/>
        <rect x="16" y={c.y} width="3" height="44" rx="1.5" fill={c.color}/>
        <rect x="28" y={c.y+10} width="24" height="24" rx="7" fill={`${c.color}18`}/>
        <text x="40" y={c.y+26} textAnchor="middle" fontSize="11" fill={c.color} fontWeight="bold">{c.name[0]}</text>
        <text x="62" y={c.y+20} fontSize="10" fill="rgba(255,255,255,0.85)" fontFamily="sans-serif" fontWeight="600">{c.name}</text>
        <text x="62" y={c.y+33} fontSize="8" fill="rgba(255,255,255,0.3)" fontFamily="monospace">{c.status}</text>
        <rect x="240" y={c.y+14} width="52" height="16" rx="8" fill={`${c.color}15`} stroke={`${c.color}30`} strokeWidth="1"/>
        <text x="266" y={c.y+25} textAnchor="middle" fontSize="8" fill={c.color} fontFamily="monospace" fontWeight="bold">{c.budget}/mo</text>
      </g>
    ))}
    <rect x="16" y="176" width="288" height="16" rx="8" fill="rgba(0,240,160,0.06)" stroke="rgba(0,240,160,0.15)" strokeWidth="1"/>
    <rect x="16" y="176" width="200" height="16" rx="8" fill="rgba(0,240,160,0.12)"/>
    <text x="160" y="187" textAnchor="middle" fontSize="7" fill={C.green} fontFamily="monospace">$2,500 MRR — 3 ACTIVE CLIENTS</text>
  </svg>
);
